import * as yup from 'yup'

import i18next from '../../../../../i18n.js'

const FINAL_BALANCE_MODEL = {
    project: 'name',
    customer: 'customer_id',
    start_date: 'start_date',
    end_date: 'end_date',
    status: 'is_active',
    team: 'team_id',
    success_manager: 'success_manager_id',
    base_price: 'rate',
    markup: 'markup',
    link_drive_operation: 'drive_url_operation',
    link_drive_management: 'drive_url_management',
}

const DEFAULT_FINAL_BALANCE_MOCK = {
    [FINAL_BALANCE_MODEL.project]: '',
    [FINAL_BALANCE_MODEL.customer]: null,
    [FINAL_BALANCE_MODEL.start_date]: null,
    [FINAL_BALANCE_MODEL.end_date]: null,
    [FINAL_BALANCE_MODEL.status]: null,
    [FINAL_BALANCE_MODEL.team]: null,
    [FINAL_BALANCE_MODEL.success_manager]: null,
    [FINAL_BALANCE_MODEL.base_price]: null,
    [FINAL_BALANCE_MODEL.markup]: null,
    [FINAL_BALANCE_MODEL.link_drive_operation]: null,
    [FINAL_BALANCE_MODEL.link_drive_management]: null,
}
const RequestValidationSchema = yup.object().shape({
    [FINAL_BALANCE_MODEL.project]: yup
        .string()
        .required(i18next.t('validation:general_form.project_required')),
    [FINAL_BALANCE_MODEL.customer]: yup
        .object()
        .required(i18next.t('validation:general_form.customer_required')),
    [FINAL_BALANCE_MODEL.start_date]: yup
        .date()
        .required(i18next.t('validation:general_form.start_date_required')),
    [FINAL_BALANCE_MODEL.end_date]: yup
        .string()
        .required(i18next.t('validation:general_form.end_date_required')),
    [FINAL_BALANCE_MODEL.status]: yup
        .object()
        .required(i18next.t('validation:general_form.status')),
    [FINAL_BALANCE_MODEL.team]: yup
        .object()
        .required(i18next.t('validation:general_form.team_leader_required')),
    [FINAL_BALANCE_MODEL.success_manager]: yup
        .object()
        .required(
            i18next.t('validation:general_form.success_manager_required')
        ),
    [FINAL_BALANCE_MODEL.base_price]: yup
        .string()
        .required(i18next.t('validation:general_form.base_price_required')),
    [FINAL_BALANCE_MODEL.markup]: yup
        .string()
        .matches(/^[1-9]\d*$/, i18next.t('validation:general_form.rate_check'))
        .required(i18next.t('validation:general_form.markup_required')),
    [FINAL_BALANCE_MODEL.link_drive_operation]: yup
        .string()
        .matches(
            /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w.-]*)*\/?$/,
            i18next.t('validation:general_form.invalid_url')
        )
        .nullable()
        .transform(value => (value === '' ? null : value)),
    [FINAL_BALANCE_MODEL.link_drive_management]: yup
        .string()
        .matches(
            /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w.-]*)*\/?$/,
            i18next.t('validation:general_form.invalid_url')
        )
        .nullable()
        .transform(value => (value === '' ? null : value)),
})

export {
    FINAL_BALANCE_MODEL,
    DEFAULT_FINAL_BALANCE_MOCK,
    RequestValidationSchema as validationSchema,
}
